/* REMOVE ANCHOR ELEMENT AND REPLACE WITH TEXT */

export default function createAnchorInlineElement(element) {
  // Remove anchor element
  const href = element.firstElementChild.getAttribute('href');
  const linkText = element.firstElementChild.innerHTML;
  const classList = element.firstElementChild.classList;
  const parentElement = element.parentElement;
  element.removeChild(element.firstElementChild);

  const icon = parentElement.firstElementChild;
  // Set text of parent element
  element.innerHTML = linkText;

  return {
    href,
    linkText,
    classList,
    icon,
  };
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/createElements/createAnchorInlineElement.js